import { createContext } from "react";

const ClientAuthContext = createContext(null);
export default ClientAuthContext;